// src/components/AppShell/AppShell.tsx
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import './AppShell.css';

export function AppShell() {
  return (
    <div className="shell">
      <Sidebar />
      <TopBar />
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
